module.exports = __webpack_public_path__ + "img/east.e69fa37d.jpg";